import { render, staticRenderFns } from "./workflow.svg.vue?vue&type=template&id=560dc896"
import script from "./workflow.svg.vue?vue&type=script&lang=ts"
export * from "./workflow.svg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('560dc896')) {
      api.createRecord('560dc896', component.options)
    } else {
      api.reload('560dc896', component.options)
    }
    module.hot.accept("./workflow.svg.vue?vue&type=template&id=560dc896", function () {
      api.rerender('560dc896', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/landing/LandingContentBox/workflow.svg.vue"
export default component.exports